import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Spin, Typography } from "antd";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Swal from "sweetalert2";

import { getInstitutionApi } from "../../../../../apiservice/setting";
import { getServiceExpenseVoucherDetailsApi } from "../../../../../apiservice/service";

import ServiceExpenseVoucherBody from "../../ServiceExpenseVoucher/components/ServiceExpenseVoucherBody";
import ServiceExpenseVoucherBodyDesignA from "../../ServiceExpenseVoucher/components/ServiceExpenseVoucherBodyDesignA";
import ReportDom from "../../../../../components/common/ReportDom";
import { useShareDocument } from "../../../../../hooks/useShareDocument";
import ShareDocumentButton from "../../../../../components/ShareButton/ShareDocumentButton";

const { Title } = Typography;

const ServiceExpenseVoucherQuick = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // ✅ get service_ex_id from route param
  const reportRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [voucher, setVoucher] = useState(null);
  const [institution, setInstitution] = useState(null);
  const [voucherNo, setVoucherNo] = useState("");
  const [accName, setAccName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");

  const {
    shareOpen,
    setShareOpen,
    email,
    setEmail,
    handleEmailShare,
    handleWhatsAppShare,
  } = useShareDocument();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: `ServiceExpenseVoucher_${id}`,
    removeAfterPrint: true,
  });

  useEffect(() => {
    fetchInstitution();
    fetchVoucher();
  }, [id]);

  useEffect(() => {
    if (shareOpen && customerEmail) {
      setEmail(customerEmail);
    }
  }, [shareOpen, customerEmail, setEmail]);     

  const fetchInstitution = async () => {
    try {
      const res = await getInstitutionApi();
      setInstitution(res.data);
    } catch {
      Swal.fire("Error loading institution!", "", "error");
    }
  };

  const fetchVoucher = async () => {
    try {
      const res = await getServiceExpenseVoucherDetailsApi({
        service_ex_id: id,
        from: "voucher",
      });

      if (res?.data?.length) setVoucher(res.data[0]);
      else Swal.fire("Voucher not found!", "", "warning");
    } catch (err) {
      Swal.fire("Failed to load voucher!", "", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          Back
        </Button>

        {/* <Title level={4} style={{ margin: 0 }}>
          Service Expense Voucher #{id}
        </Title> */}

        <div style={{ display: "flex", gap: 8 }}>
          <ShareDocumentButton
            disabled={!voucher}
            shareOpen={shareOpen}
            setShareOpen={setShareOpen}
            email={email}
            setEmail={setEmail}
            loading={loading}
            onEmail={() =>
              handleEmailShare({
                url: `/print/service-expense/${id}`,
                fileName: `ServiceExpense_${
                  voucherNo || "Voucher"
                }.pdf`,
                name: accName || "",
                docNo: voucherNo || "Voucher",
              })
            }
            onWhatsApp={() =>
              handleWhatsAppShare({
                url: `/print/service-expense/${id}`,
                fileName: `ServiceExpense_${
                  voucherNo || "Voucher"
                }.pdf`,
                text: `Hello ${accName || ""}, Your Service Expense Voucher ${
                  voucherNo || "Voucher"
                } is ready. Download here:`,
              })
            }
          />

          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            disabled={!voucher}
          >
            Print
          </Button>
        </div>
      </div>

      <Card className="shadow-md rounded-xl">
        {loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <Spin />
          </div>
        ) : !voucher ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            Voucher not found
          </div>
        ) : (
          <ServiceExpenseVoucherBody
            service_ex_id={id}
            institution={institution}
            setVoucherNo={setVoucherNo}
            setAccName={setAccName}
            setCustomerEmail={setCustomerEmail}
          />
        )}
      </Card>

      {voucher && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            mode={institution?.print_template === "design_a" ? "no-title" : undefined}
            // title="Service Expense Voucher"
            renderTable={() =>
              institution?.print_template === "design_a" ? (
                <ServiceExpenseVoucherBodyDesignA service_ex_id={id} />
              ) : (
                <ServiceExpenseVoucherBody
                  service_ex_id={id}
                  institution={institution}
                  printMode
                />
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default ServiceExpenseVoucherQuick;
